import script from "./conferenceDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./conferenceDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./conferenceDetailPage.vue?vue&type=style&index=0&id=3ff4c9ca&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ff4c9ca"]])

export default __exports__